import React from 'react';
import AutoSaveDropdown from '../AutoSaveFormFields/AutoSaveDropdown';
import {isNoU} from "utils/DBUtils";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";

/**
 *  We need a custom component to prepopulate a dropdown with a resource
 *  list.  Ideally at some point we'll pass a prop into our dropdown
 *  and handle this automatically.  Or make a ResourceDropdown component.
 */
const UserTagDropdown = (props) => {
  // let results = props.formProxy.grandParentCurrentResource.results;
  // let options = [];
  // if ( !isNoU(results) ) {
  //   for(let i=0;i<results.length;i++) {
  //     options.push({
  //       text: results[i].title ? results[i].title : (i+1),
  //       value: results[i].id
  //     });
  //   }
  // }

  let options = [];
  if ( !isNoU(props.userTags) ) {
    for (let i=0; i<props.userTags.length;i++) {
      let userTag = props.userTags[i];
      console.log('tag is ', userTag);
      options.push({
        text: userTag.name,
        value: userTag.id
      });
    }
  }

  console.log('final options are ', options);

  return <AutoSaveDropdown {...props} options={options}/>
};

UserTagDropdown.propTypes = {};

export default UserTagDropdown;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/UserTagDropdown.jsx